import React from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { AsyncScrumOnboardingModal } from '@atlassian/jira-software-onboarding-modals/src/ui/scrum-onboarding-modal/async.tsx';
import { useShouldShowScrumOnboardingModal } from '@atlassian/jira-software-onboarding-modals/src/ui/scrum-onboarding-modal/utils';
import { AsyncWelcomeModal } from '@atlassian/jira-software-onboarding-modals/src/ui/welcome-modal/async.tsx';
import { useShouldShowWelcomeModal } from '@atlassian/jira-software-onboarding-modals/src/ui/welcome-modal/utils';
import {
	DeleteCardType,
	MoveCardsActiveSprintType,
	AssignIssueParentType,
	GlobalIssueCreateType,
	SplitIssueType,
	MoveCardsSelectTransitionType,
	FlagWithCommentType,
} from '../../model/modals/types';
import { useBacklogSelector } from '../../state';
import { getIsCompanyManaged } from '../../state/selectors/app';
import { getHasAnyIssueTypeWithRequireFields } from '../../state/selectors/card-type';
import { makeIsModalOpen } from '../../state/selectors/modals';
import AssignIssueParentModal from './assign-issue-parent-modal';
import CardDeleteModal from './card-delete-modal';
import ConfluenceRetroCreateModal from './confluence-retro-create';
import ConfluenceRetroCrossFlowModal from './confluence-retro-cross-flow';
import ConfluenceRetroCrossJoinModal from './confluence-retro-cross-join';
import ConfluenceRetroPublishedModal from './confluence-retro-published';
import FlagWithCommentModal from './flag-with-comment';
import GlobalIssueCreateModal from './global-issue-create';
import GlobalIssueCreateModalCmp from './global-issue-create-cmp/async';
import { IssueTransitionModal } from './issue-transition';
import MoveCardsActiveSprintModal from './move-cards-active-sprint-modal';
import { SelectTransitionsModal } from './select-transitions-modal';
import SplitIssueModal from './split-issue';

const Modals = () => {
	const isModalOpen = useBacklogSelector(makeIsModalOpen);
	const isCompanyManaged = useBacklogSelector(getIsCompanyManaged);
	const isCardDeleteModalOpen = isModalOpen(DeleteCardType);

	const isMoveCardsActiveSprintModalOpen = isModalOpen(MoveCardsActiveSprintType);
	const isAssignIssueParentModalOpen = isModalOpen(AssignIssueParentType);
	const isGlobalIssueCreateModal = isModalOpen(GlobalIssueCreateType);
	const isSplitIssueModalOpen = isModalOpen(SplitIssueType);
	const isSelectTransitionsModalOpen = isModalOpen(MoveCardsSelectTransitionType);
	const isFlagWithCommentModalOpen = isModalOpen(FlagWithCommentType);
	const hasAnyIssueTypeWithRequiredFields = useBacklogSelector(getHasAnyIssueTypeWithRequireFields);
	const shouldShowScrumOnboardingModal = useShouldShowScrumOnboardingModal();

	const GlobalIssueCreateModalComponent = isCompanyManaged
		? GlobalIssueCreateModalCmp
		: GlobalIssueCreateModal;

	const shouldShowWelcomeModal = useShouldShowWelcomeModal('backlog');

	return (
		// div is required here, otherwise backlog layout breaks when a modal pops up
		// eslint-disable-next-line jira/react/no-empty-divs
		<div>
			{shouldShowScrumOnboardingModal && <AsyncScrumOnboardingModal />}
			{isCardDeleteModalOpen && <CardDeleteModal />}

			{isMoveCardsActiveSprintModalOpen && <MoveCardsActiveSprintModal />}
			<ModalTransition>
				{isAssignIssueParentModalOpen && <AssignIssueParentModal />}
			</ModalTransition>
			{(hasAnyIssueTypeWithRequiredFields || isGlobalIssueCreateModal) && (
				<GlobalIssueCreateModalComponent />
			)}
			{isSplitIssueModalOpen && <SplitIssueModal />}
			{isSelectTransitionsModalOpen && <SelectTransitionsModal />}
			{isFlagWithCommentModalOpen && <FlagWithCommentModal />}
			<ConfluenceRetroCreateModal />
			<ConfluenceRetroCrossFlowModal />
			<ConfluenceRetroCrossJoinModal />
			<ConfluenceRetroPublishedModal />
			<IssueTransitionModal />
			{shouldShowWelcomeModal && <AsyncWelcomeModal source="backlog" />}
		</div>
	);
};

export default Modals;
